/** Hex swatches shown in Add / Edit category modals (order = display order). */
export const CATEGORY_COLOR_SWATCHES = [
  "#22c55e",
  "#10b981",
  "#3b82f6",
  "#a855f7",
  "#f97316",
  "#ff2d3f",
  "#ec4899",
  "#64748b",
  "#7dd3fc",
  "#92400e",
  "#171717",
] as const;

export const DEFAULT_CATEGORY_COLOR = "#64748b";
